"use strict";

module.exports = function (column, e) {
  // console.log('dragover->' + column)
  // console.log(this.opts.ColumnDragging)
  // console.log(this.opts.ColumnDragging !== column)
  // console.log(this.columns)

  var ix1 = -1;
  var ix2 = -1;

  if (this.opts.ColumnDragging !== column) {
    for (var ix in this.columns) {
      if (this.columns[ix] === column) {
        ix1 = ix;
      } else if (this.columns[ix] === this.opts.ColumnDragging) {
        ix2 = ix;
      }
    }

    this.columns[ix1] = this.opts.ColumnDragging;
    // this.columns[ix2] = column
    this.$set(this.columns, ix1, this.opts.ColumnDragging);
    this.$set(this.columns, ix2, column);
  }

  //console.log(this.columns)
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/dragover-column.js